import gql from 'graphql-tag';
import ModifierFragment from './ModifierFragment';

const ItemFragment = gql`
  fragment Item on Item {
    id
    applyTaxRate
    afterDiscountAmount
    locationId
    checkDiscountAmount
    checkDiscountId
    checkDiscountType
    checkDiscountValue
    checkNumber
    courseNumber
    forcedModifierGroupId
    forcedModifiersSummary
    forcedModifiersPrice
    name
    notes
    price
    quantity
    orderId
    menuCategoryId
    menuItemId
    openItem
    optionalModifierListId
    optionalModifiersSummary
    orderId
    initialQuantity
    includedTax
    includedTaxRate
    isIncludedTax
    isTaxExempt
    itemDiscountAmount
    itemDiscountId
    itemDiscountName
    itemDiscountType
    itemDiscountValue
    lastChangedTimestamp
    lastModifiedTimestamp
    printerId
    printToKitchen
    seatNumber
    serverDate
    splitFactor
    subtotal
    subtotalWithModifiers
    taxAmount
    totalWithTax
    tax1
    tax2
    tax3
    tax4
    tax5
    tax1Name
    tax2Name
    tax3Name
    tax4Name
    tax5Name
    tax1Rate
    tax2Rate
    tax3Rate
    tax4Rate
    tax5Rate
    tax1Subtotal
    tax2Subtotal
    tax3Subtotal
    tax4Subtotal
    tax5Subtotal
    togoStatus
    void
    applyTaxRate
    modifiers {
      ...Modifier
    }
  }

  ${ModifierFragment}
`;

export default ItemFragment;


// WEBPACK FOOTER //
// ./src/graphql/fragments/item/ItemFragment.js